import WelcomeContent from '../components/WelcomeContent/WelcomeContent'
import AdBanner from '../components/AdBanner/AdBanner'

const Home = () => {
    return(<>
    <WelcomeContent />
    <AdBanner />
    </>)
}
export default Home;